import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0198',
    ecrans: ['00-2', '01-2'],
    params: ['?id', '?blocleint', '?prscleint', '?prucleint']
});
